import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { LinkProviderType } from '../types/LinkProviderType';

export function convertToLinkProviderType(
    providerType: AttachmentDataProviderType
): LinkProviderType {
    switch (providerType) {
        case AttachmentDataProviderType.OneDrivePro:
            return LinkProviderType.OneDrivePro;
        case AttachmentDataProviderType.OneDriveConsumer:
            return LinkProviderType.OneDriveConsumer;
        case AttachmentDataProviderType.Dropbox:
        case AttachmentDataProviderType.WopiDropbox:
            return LinkProviderType.Dropbox;
        case AttachmentDataProviderType.Box:
        case AttachmentDataProviderType.WopiBox:
            return LinkProviderType.Box;
        case AttachmentDataProviderType.GDrive:
            return LinkProviderType.GDrive;
        default:
            throw new Error(`Link does not support ${providerType}`);
    }
}
